import ContactProfileImage from '@app/components/ContactProfileImage'
import { IAssociatedContact } from '@app/models/AssociatedContact'
import classNames from 'classnames'
import { List } from 'immutable'
import * as React from 'react'

export interface IItemLeadsListProps {
  className?: string
  connections: List<IAssociatedContact>
  style?: React.CSSProperties
}

export default class ItemConnectionsList extends React.PureComponent<
  IItemLeadsListProps
> {
  public render() {
    if (this.props.connections.size === 0) {
      return (
        <div className={this.props.className} style={this.props.style}>
          No Connections
        </div>
      )
    }

    const connections = this.props.connections.map((contact) => {
      if (contact === undefined) {
        return null
      }

      return (
        <div
          className='my-2'
          style={{ width: '300px' }}
          key={contact.contactId}
        >
          <a
            className='d-flex flex-row'
            target='_blank'
            rel='noreferrer'
            style={{ color: 'black' }}
            href={`/connection/${contact.contactId}`}
          >
            <ContactProfileImage contact={contact.contactId} size={70} />
            <div className='ml-2 align-self-center'>
              <div>
                <strong>{contact.name}</strong>
              </div>
            </div>
          </a>
        </div>
      )
    })

    return (
      <div
        className={classNames(
          'd-flex flex-wrap justify-content-between',
          this.props.className,
        )}
        style={this.props.style}
      >
        {connections}
      </div>
    )
  }
}
